import { FONT_WEIGHTS } from "../../../constants/fontWeights";

export const defaultStyles = {
  backgroundColor: "var(--theme-email-color-background-primary)",
  padding: {
    paddingTop: "12",
    paddingBottom: "12",
    paddingRight: "24",
    paddingLeft: "24",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginRight: "0",
    marginLeft: "0",
  },
  content: {
    color: "var(--theme-email-p1-color-text)",
    textAlign: "center" as const,
    fontSize: "12px",
    fontWeight: String(FONT_WEIGHTS.NORMAL),
    link: {
      color: "#545861",
      textDecoration: "underline",
      margin: "0 4px",
    },
    line: {
      padding: "8px 0",
    },
    logo: {
      width: "100%",
      padding: "8px 0",
      image: {
        height: "20px",
      },
      icon: {
        height: "24px",
        width: "24px",
      },
      communityName: {
        fontSize: "14px",
        fontWeight: String(FONT_WEIGHTS.MEDIUM),
      },
    },
    community: {
      width: "100%",
      padding: "6px 0",
    },
    address: {
      width: "100%",
      padding: "6px 0",
    },
    preferences: {
      width: "100%",
      padding: "6px 0",
    },
  },
};
